import { useContext, useState } from 'react';
import { Table } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import { ActionButton } from '@hdi-seguros/web-components.action-button';
import { HEADERS_PAYMENT_METHOD } from '../../../../shared/utils/headers-payment-method';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import { ContentSection } from '../../../../../../../shared/components';
import { GenericDataFormContext } from '../../../../shared/contexts/GenericDataForm';
import { EditPaymentMethodModal } from '../EditPaymentMethodModal';
import { PaymentMethodsAdded } from '../../interfaces';

export const TableMethodsPaymentAdded = () => {
  const { paymentMethodsDataTable = [] } = useContext(StepThreeFormContext);
  const { canShowSpinner } = useContext(GenericDataFormContext);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentMethodsAdded | null>(null);
  
  const handleEdit = (paymentMethod: PaymentMethodsAdded) => {
    setSelectedPaymentMethod(paymentMethod);
    setIsEditModalOpen(true);
  };

  const handleEditSuccess = () => {
    setIsEditModalOpen(false);
    setSelectedPaymentMethod(null);
  };

  const handleEditCancel = () => {
    setIsEditModalOpen(false);
    setSelectedPaymentMethod(null);
  };

  const updatedColumns = HEADERS_PAYMENT_METHOD.map((col) => {
    if (col.key === 'action') {
      return {
        ...col,
        render: (_: any, record: PaymentMethodsAdded) => {
          const actionContent = record.action;
          if (actionContent && typeof actionContent === 'object' && 'props' in actionContent) {
            return (
              <div style={{ display: 'flex', gap: '8px' }}>
                <ActionButton
                  label=""
                  icon={<EditOutlined />}
                  color="default"
                  type="secondary"
                  onClick={() => handleEdit(record)}
                />
                {actionContent}
              </div>
            );
          }
          return actionContent;
        },
      };
    }
    return col;
  });
  
  return (
    <>
      <ContentSection hasCard={false}>
        <Table
          bordered
          className='w-100'
          columns={updatedColumns}
          dataSource={paymentMethodsDataTable}
          pagination={false}
          scroll={{ x: 'max-content' }}
          loading={canShowSpinner}
        />
      </ContentSection>
      <EditPaymentMethodModal
        open={isEditModalOpen}
        onCancel={handleEditCancel}
        paymentMethod={selectedPaymentMethod}
        onSuccess={handleEditSuccess}
      />
    </>
  );
};
